import CommonHelmet from '@src/components/CommonHelmet';
import RegistrationRequiresApproval from '@src/features/company/company-user/RegistrationRequiresApproval';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';

function CompanyRegistrationRequiresApproval() {
  return (
    <CompanyCenterCardLayout showCommonComponents={true}>
      <CommonHelmet />
      <RegistrationRequiresApproval />
    </CompanyCenterCardLayout>
  );
}

export default CompanyRegistrationRequiresApproval;
